import { Injectable } from '@angular/core';
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistObjectModel,
  QueryColumn,
  QueryColumnSortOrder,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalRole } from '../user-right/user-right.component';
import { Permession } from '../user-right/user-settings/user-settings.component';
import { DataService, ObjectKeys } from './data.service';
@Injectable({
  providedIn: 'root',
})
export class PermessionService {
  private roleSubject = new BehaviorSubject<GlobalRole>(null);
  public columns: QueryColumn[] = [];
  constructor(private coreDataService: CoreDataService, private dataService: DataService) {
    this.columns = [
      this.coreDataService.createQueryColumn('ParentId', 'ParentId', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Designation', 'permessionName', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('BoolValue', 'permession', QueryColumnSortOrder.None),
    ];
  }
  public setRole(role: GlobalRole): void {
    this.roleSubject.next(role);
  }

  public getRole(): Observable<GlobalRole> {
    return this.roleSubject.asObservable();
  }
  public getPermessions(roleId: string): Observable<any> {
    const opath = `ParentId='${roleId}'`;

    return this.dataService.readObjects(ObjectKeys.PROPERTY, this.columns, opath).pipe(
      catchError((error) => {
        console.error('Error fetching permissions:', error);
        return of([]);
      })
    );
  }

  public persistPermession(permession: Permession, persistMode: number): Observable<ArrayBuffer> {
    const propertyColumns: TargetColumnValue[] = [
      { Name: 'Designation', Value: permession.permessionName },
      { Name: 'BoolValue', Value: permession.permession },
      { Name: 'Type', Value: 0 },
      { Name: 'ParentId', Value: permession.ParentId },
      { Name: 'TextValue', Value: permession.permession },
      { Name: 'ParentObjectType', Value: ObjectKeys.PICKLISTITEM },
    ];

    const propertyPersistQuery: TargetObjectData = new TargetObjectData();
    propertyPersistQuery.ObjectKey = new ObjectKey();
    propertyPersistQuery.ObjectKey.ObjectType = ObjectKeys.PROPERTY;

    if (permession.Id) {
      propertyPersistQuery.ObjectKey.Id = permession.Id;
    }

    propertyPersistQuery.Mode = persistMode;
    propertyPersistQuery.TargetColumns = propertyColumns;

    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = propertyPersistQuery;

    return this.coreDataService.executePersistObjectQuery(persistObject).pipe(
      catchError((error) => {
        console.error('Error persisting permissions:', error);
        return throwError(() => new Error(error));
      })
    );
  }
}
